module.exports = __webpack_public_path__ + "assets/img/43201676bb15a7b38d4de0aaf59fcb01.webp";